
define(
	'Code25.CaterpartsGlobal.Categories'
	, [
		"Utils"
	]
	, function (
		Utils
	) {
		'use strict';
		return {
			mount: function mount(container) {


				var _categories;
				var HeaderMenuView = require("Header.Menu.View");
				if (HeaderMenuView) {
					_.extend(HeaderMenuView.prototype, {

						getContext: _.wrap(HeaderMenuView.prototype.getContext, function (getContext) {

							var res = getContext.apply(this, _.rest(arguments));
							var scCategory;


							if (_categories) {
								res.categories = _categories;
							} else if (res.categories.length > 0) {
								var letter, lastLetter;
								for (var j = res.categories.length - 1; j >= 0; j--) {
									if (res.categories[j].categories) {
										for (var i = 0; i < res.categories[j].categories.length; i++) {
											scCategory = res.categories[j].categories[i];
											if (scCategory.categories) {
												scCategory.categories.sort(function (A, B) {
													return A.text.localeCompare(B.text);
												});
												for (var m = 0; m < scCategory.categories.length; m++) {
													letter = scCategory.categories[m].text.substring(0, 1);
													if (letter != lastLetter) {
														scCategory.categories[m].letter = letter;
														lastLetter = letter;
													}
												}
											}

										}
									}

								}

								_categories = JSON.parse(JSON.stringify(res.categories));
								//console.log(_categories);
							}
							return res;

						})
					});
				}


			}

		}

	});
